import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationsRequest } from "../../../redux/actions/notification";
import { EmptyState } from "../../../components/EmptyState";
import moment from "moment";
import { notificationTypes } from "../../../constants/translations";
import Button from "../../../components/Button";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";

const Notifications = ({ t, history }) => {
  const dispatch = useDispatch();
  const { list, activePage, totalPageCount, loading } = useSelector(
    (state) => state.notification
  );
  const { organizationId } = useSelector(
    (state) => state.authorization.user.organization
  );

  const [sortedColumn, setSortedColumn] = useState("createdDate");
  const [sortDirection, setSortDirection] = useState("desc");
  const size = 10;
  const fieldNames = {
    createdDate: "CREATED_DATE",
    organizationName: "ORGANIZATION_NAME",
    type: "TYPE",
    message: "MESSAGE",
  };
  const translations = notificationTypes(t);
  const redirectionObject = {
    BILATERAL_AGREEMENT_SEND: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_RECEIVE: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_APPROVAL: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_PENDING_APPROVAL: "/bilateral-agreement-operations",
    BILATERAL_AGREEMENT_CANCEL: "/bilateral-agreement-operations",
    OBJECTION: "/objections",
    PROCESS_CHANGES: "/system-parameters",
    DOCUMENT_EXPORT: "/active-certificates",
    DOCUMENT_REPEAL: "/suspended-certificates",
    REPEAL_INFORMATION: "/suspended-certificates",
    REDEMPTION: "/redemption-operations-history",
    DOCUMENT_CANCEL: "/canceled-certificates",
    ORGANIZE_MARKET_MATCH_UP_INFORMATION: "/offers-and-matches",
    ORGANIZE_MARKET_CANCEL: "/offers-and-matches",
    GDDK: "/gddk-operations",
    LIMIT_OPERATIONS: "/user-parameters",
  };
  const notificationsColumns = [
    {
      name: t("pages.default.certificates.table.organizationName"),
      selector: "organizationName",
      sortable: true,
      showTitle: true,
      cell: (row) => row.organizationName || "EPİAŞ",
    },
    {
      name: t("pages.default.notifications.table.type"),
      selector: "type",
      sortable: true,
      cell: (row) => translations[row.type],
    },
    {
      name: t("pages.default.notifications.table.date"),
      selector: "createdDate",
      sortable: true,
      cell: (row) => moment(row.createdDate).format("DD.MM.YYYY HH:mm:ss"),
    },
    {
      name: t("pages.default.notifications.table.message"),
      selector: "message",
      sortable: true,
      showTitle: true,
    },
    {
      name: t("pages.default.notifications.table.process"),
      selector: "redirect",
      sortable: false,
      cell: (row) => (
        <Button
          title={t("pages.default.notifications.details")}
          label={t("pages.default.notifications.details")}
          onClick={() => history.push(redirectionObject[row.type])}
        />
      ),
      width: "80px",
    },
  ];

  useEffect(() => {
    handleFetchData(activePage, sortedColumn, sortDirection.toUpperCase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFetchData = (activePage, selector, direction) => {
    dispatch(
      getNotificationsRequest({
        organizationId,
        sort: {
          fieldName: fieldNames[selector],
          sortType: direction,
        },
        page: activePage,
        size,
      })
    );
  };

  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.notifications.title")}
      </h5>
      <div className="km__p--card">
        <div className="km__p--notification-settings-table-container">
          <DataTableServerSideRendering
            columns={notificationsColumns}
            data={list}
            rowKey="id"
            sortedColumn={sortedColumn}
            setSortedColumn={setSortedColumn}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            pagination
            activePage={activePage}
            totalPageCount={totalPageCount}
            handleFetchData={handleFetchData}
          />
        </div>
        {!loading && list.length === 0 && (
          <EmptyState
            icon="file-text"
            text={t("pages.default.notifications.notFound")}
          />
        )}
      </div>
    </>
  );
};

export default Notifications;
